import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import findResult, { removeEmpty } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import TableHeaderAddRow from '@/components/table/TableHeaderAddRow';
import useDebounce from '@/utils/debounce';
import {
  addUsergroupUsers, updateUsergroupUsersToAdd as updateUsergroupUsersToAddAction,
} from '../actions/usergroupUsers';
import MembersDropdown from '../../membership/components/MembersDropdown';
import { fetchUsergroupSearchUsers, updateUsergroupSearchFilter } from '../actions/usergroups/read';

const UsergroupUsersAddRow = ({
  addMembers,
  assignableMembers,
  assigningMembers,
  fetchData,
  filter,
  readStatus,
  updateFilter,
  updateStatus,
  updateUsergroupUsersToAdd,
}) => {
  const debouncedFetch = useDebounce(fetchData);

  const onMembersChange = useCallback((userIds) => {
    const toAdd = removeEmpty(userIds.map((value) => assignableMembers.find(({ uuid }) => uuid === value)));
    updateUsergroupUsersToAdd(toAdd);
  }, [updateUsergroupUsersToAdd, assignableMembers]);

  const onFilterChange = useCallback((value) => {
    updateFilter(value);
    debouncedFetch(value);
  }, [updateFilter, debouncedFetch]);

  return (
    <TableHeaderAddRow
      colSpan={3}
      disabled={assigningMembers.length === 0 || updateStatus === states.PENDING}
      entity="user.group"
      onClick={addMembers}
      dataPosition="bottom right"
    >
      <MembersDropdown
        autoFocus
        filter={filter}
        members={assignableMembers}
        onChange={onMembersChange}
        onFilterChange={onFilterChange}
        readStatus={readStatus}
        text={assigningMembers.map((member) => member.uuid)}
        usersOnly
      />
    </TableHeaderAddRow>
  );
};

const mapStateToProps = (
  { userGroups: { userGroups } },
  { category, code },
) => {
  const item = findResult(userGroups, category, code);
  const {
    results, readStatus, filter, readErrors,
  } = item?.userSearch || {
    filter: '',
    results: [],
    readStatus: states.NONE,
    readErrors: [],
  };
  const existingMembers = item?.users?.results || [];
  const uuids = existingMembers.map(({ uuid }) => uuid);
  const assignableMembers = results.filter(({ uuid }) => !uuids.includes(uuid));
  const assigningMembers = item?.users?.toAdd || [];

  return {
    assignableMembers: assignableMembers.concat(assigningMembers),
    assigningMembers,
    filter,
    readErrors,
    readStatus,
    updateStatus: item?.users?.updateStatus,
  };
};

const mapDispatchToProps = (dispatch, { category, code }) => ({
  addMembers: () => dispatch(addUsergroupUsers(category, code)),
  fetchData: (filter) => dispatch(fetchUsergroupSearchUsers(category, code, filter)),
  updateFilter: (filter) => dispatch(updateUsergroupSearchFilter(category, code, filter)),
  updateUsergroupUsersToAdd: (users) => dispatch(updateUsergroupUsersToAddAction(category, code, users)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsergroupUsersAddRow);
